import * as React from "react";
import { useNavigate } from "react-router-dom";
import {
  Avatar,
  Box,
  Button,
  Grid,
  Stack,
  Paper,
  Typography,
  ListItem,
  List,
} from "@mui/material";

import DelendDrawer from "../../../components/AppBar/DelendDrawer";
import { DelendButton } from "../../../components/Buttons";
import {
  AccountBalance,
  Check,
  PersonOutline,
  Storefront,
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";

import {
  maskPhone,
  documentNumberFormatter,
  dateFormatter,
} from "../../../services/UtilsService";
import PersonService from "../../../services/PersonService";
import DelendCentralizedCircularProgress from "../../../components/CircularProgress/DelendCentralizedCircularProgress";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#F5F5F8",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: "#8087A6",
  display: "flex",
  alignItems: "center",
}));

const ConsentBasicInformation = ({ person }) => {
  const isLegalPerson = (documentNumber) => {
    return documentNumber.length > 11;
  };
  return (
    <Grid
      container
      spacing={2}
      margin={"24px 0px"}
      sx={{
        border: "1px solid grey",
        borderRadius: "8px",
        borderColor: "#E9EBF0",
      }}
    >
      <Grid
        display={"flex"}
        item
        sx={{
          borderBottom: "1px solid grey",
          padding: "20px 0px",
          borderColor: "#E9EBF0",
        }}
        flexGrow={1}
        xs={12}
      >
        {isLegalPerson(person.documentNumber) ? (
          <Avatar
            sx={{
              width: 40,
              height: 40,
              backgroundColor: "#FFF",
              border: "1px solid #820AD1",
              borderStyle: "dashed",
            }}
          >
            <Storefront sx={{ color: "#820AD1" }} />
          </Avatar>
        ) : (
          <Avatar
            sx={{
              width: 40,
              height: 40,
              backgroundColor: "#FFF",
              border: "1px solid #503DFC",
              borderStyle: "dashed",
            }}
          >
            <PersonOutline sx={{ color: "#503DFC" }} />
          </Avatar>
        )}

        <Box>
          <Typography
            sx={{ ml: "8px", fontWeight: 400, fontSize: "16px" }}
            noWrap
          >
            {person.name ? person.name : "Nome não informado"}
          </Typography>
          <Typography
            sx={{
              ml: "8px",
              fontWeight: 400,
              fontSize: "14px",
              color: "#8087A6",
            }}
            noWrap
          >
            {documentNumberFormatter(person.documentNumber)}
          </Typography>
        </Box>
      </Grid>
      <Grid
        item
        flexGrow={1}
        xs={6}
        sx={{
          borderRight: "1px solid grey",
          padding: "20px 0px",
          borderColor: "#E9EBF0",
        }}
      >
        <Typography
          sx={{
            ml: "8px",
            fontWeight: 400,
            fontSize: "14px",
            color: "#575757",
            padding: "8px 0px",
          }}
          noWrap
        >
          Contato
        </Typography>
        <Typography
          sx={{
            ml: "8px",
            fontWeight: 400,
            fontSize: "16px",
          }}
          noWrap
        >
          {person.mobilePhone
            ? maskPhone(person.mobilePhone)
            : "Celular não informado"}
        </Typography>
        <Typography
          sx={{
            ml: "8px",
            fontWeight: 400,
            fontSize: "14px",
            color: "#8087A6",
            padding: "8px 0px",
          }}
          noWrap
        >
          {person.email ? person.email : "E-mail não informado"}
        </Typography>
      </Grid>
      <Grid
        item
        sx={{
          borderRight: "1px solid grey",
          padding: "20px 0px",
          borderColor: "#E9EBF0",
        }}
        flexGrow={1}
        xs={6}
      >
        <Typography
          sx={{
            ml: "8px",
            fontWeight: 400,
            fontSize: "14px",
            color: "#575757",
            padding: "8px 0px",
          }}
          noWrap
        >
          Data do cadastro
        </Typography>
        <Typography
          sx={{
            ml: "8px",
            fontWeight: 400,
            fontSize: "16px",
          }}
          noWrap
        >
          {dateFormatter(person.createdAt)}
        </Typography>
        <Typography
          sx={{
            ml: "8px",
            fontWeight: 400,
            fontSize: "14px",
            color: "#8087A6",
            padding: "8px 0px",
          }}
          noWrap
        >
          {person.createdBy
            ? `por ${person.createdBy.name}`
            : "por Não definido"}
        </Typography>
      </Grid>
    </Grid>
  );
};

const ConsentStatusByParticipant = ({ connection }) => {
  return (
    <ListItem>
      <Grid container spacing={2}>
        <Grid item display={"flex"} alignItems={"center"} xs={12}>
          <Avatar
            sx={{
              width: 36,
              height: 36,
              backgroundColor: "#FFF",
              border: "1px solid #820AD1",
              borderStyle: "dashed",
            }}
          >
            <AccountBalance sx={{ color: "#820AD1" }} />
          </Avatar>
          <Typography
            sx={{
              ml: "8px",
              fontWeight: 400,
              fontSize: "16px",
              color: "#00010C",
              padding: "8px 0px",
            }}
            noWrap
          >
            {connection.brand}
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Stack direction="row" spacing={1}>
            {connection.steps.map((step, index) => {
              if (
                step &&
                step.status === "DONE" &&
                connection.steps[index + 1] &&
                connection.steps[index + 1].status !== "DONE"
              ) {
                return (
                  <Item
                    sx={{
                      backgroundColor: "#269800",
                      color: "#EEF7EB",
                    }}
                  >
                    <Typography
                      sx={{ fontWeight: 400, fontSize: 14 }}
                      color="inherit"
                      noWrap
                    >
                      {step.title}
                    </Typography>
                  </Item>
                );
              }

              if (step.status === "DONE") {
                return (
                  <Item
                    sx={{
                      backgroundColor: "#EEF7EB",
                      color: "#269800",
                    }}
                  >
                    <Check width={16} height={16} />
                    <Typography
                      sx={{ fontWeight: 400, fontSize: 14 }}
                      color="inherit"
                    >
                      {step.title}
                    </Typography>
                  </Item>
                );
              }

              return <Item>{step.title}</Item>;
            })}
          </Stack>
        </Grid>
        <Grid item display={"flex"} justifyContent={"end"} xs={12}>
          <Typography
            sx={{ fontWeight: 400, fontSize: 14, color: "#8087A6" }}
            noWrap
            display={"flex"}
            alignItems={"center"}
          >
            <Box
              style={{
                width: "6px",
                height: "6px",
                backgroundColor: "#269800",
                borderRadius: "10px",
                marginRight: "6px",
              }}
            />
            Atualizado {dateFormatter(connection.updatedAt)}
          </Typography>
        </Grid>
      </Grid>
    </ListItem>
  );
};

const OpenFinanceSummarizedInformationTab = ({
  open,
  handleDrawerClose,
  person,
  openNewOpenFinanceModal
}) => {
  const navigate = useNavigate();
  const [connections, setConnections] = React.useState([]);
  const [isLoading , setIsLoading] = React.useState(false);

  const defineCurrentStep = (currentBank) => {
    let currentStep = 0;
    for (let index = 0; index < currentBank.steps.length; index++) {
      const element = currentBank.steps[index];
      if (element.status === "DONE") currentStep = index + 1;
    }
    return currentStep;
  };


  React.useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const response = await PersonService.getPersonConsent(person.personUuid);
      setIsLoading(false);
      response.forEach((element) => {
        element.currentStep = defineCurrentStep(element);
      });
      setConnections(response)
     }
     if (person)
      fetchData();
  }, [person]);

  const handleNewOpenFinanceButtonClick = () => {
    handleDrawerClose();
    openNewOpenFinanceModal({documentNumber : person.documentNumber, mobilePhone : person.mobilePhone});
  }

  const openSupersetVisualizer = () => {
    navigate(`/dashboard/view/customer/dashboard/${person.personUuid}`);
  };

  if (person === null) {
    return null;
  }

  return (
    <DelendDrawer
      open={open}
      handleCloser={handleDrawerClose}
      title="Resumo do Open Finance"
      endButton={
        <DelendButton
          text={"Ver Open Finance"}
          padding={"12px 16px"}
          onClick={openSupersetVisualizer}
        />
      }
    >
      <ConsentBasicInformation person={person} />
      <Box display={"flex"}>
        <Typography
          sx={{
            fontWeight: 400,
            fontSize: "20px",
            color: "#00010C",
            padding: "0px 0px",
          }}
          noWrap
        >
          Status dos consentimentos
        </Typography>

        <Box flexGrow={1} />

        <Button
          sx={{
            textTransform: "none",
            borderRadius: 50,
            borderColor: "#E9EBF0",
            color: "#00010C",
          }}
          variant="outlined"
          onClick={handleNewOpenFinanceButtonClick}
        >
          Solicitar mais instituições
        </Button>
      </Box>
      <List>
        {isLoading ?  
           <Box style={{paddingTop: 180}}>
              <DelendCentralizedCircularProgress absolute="false"/>
           </Box>
         : connections.map((connection) => (
          <ConsentStatusByParticipant connection={connection} />
        ))}
      </List>
    </DelendDrawer>
  );
};

export default OpenFinanceSummarizedInformationTab;
